<!--
 * @Description: 缺陷清单详情
-->
<template>
  <div class="w-full h-full overflow-auto">
    <CategoryTitle class="mt-10px mb-5px" title="基本信息"></CategoryTitle>
    <div class="text-14px" style="line-height: 28px">
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">缺陷登录编号：</span>
        <span class="flex-1 break-words">{{ currentRelationData.defect_login_code }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障现象描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.symptoms_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">工作类型描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.work_type_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">主管部门：</span>
        <span class="flex-1 break-words">{{ currentRelationData.department }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">变更人：</span>
        <span class="flex-1 break-words">{{ currentRelationData.changed }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">变更日期：</span>
        <span class="flex-1 break-words">{{ currentRelationData.changed_date }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">专业描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.speciality_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">缺陷描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.defect_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">缺陷状态：</span>
        <span class="flex-1 break-words">{{ currentRelationData.defect_state }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">报告人：</span>
        <span class="flex-1 break-words">{{ currentRelationData.reporter }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">报告日期：</span>
        <span class="flex-1 break-words">{{ currentRelationData.bgrqort_data }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">报告人部门：</span>
        <span class="flex-1 break-words">{{ currentRelationData.report_department }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">kks编码：</span>
        <a class="truncate cursor-pointer text-blue-500" @click="findNodeByCode(currentRelationData.kks_code)">
          {{ currentRelationData.kks_code }}
        </a>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">kks描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.kks_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">设备编码：</span>
        <span class="flex-1 break-words">{{ currentRelationData.equipment_code }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">分类描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.equipment_type_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">设备描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.equipment_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障类别：</span>
        <span class="flex-1 break-words">{{ currentRelationData.fault_code }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障类别描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.fault_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">机组描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.sets_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">状态日期：</span>
        <span class="flex-1 break-words">{{ currentRelationData.status_date }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">响应等级：</span>
        <span class="truncate">{{ currentRelationData.response }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">响应等级描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.response_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">项目负责人：</span>
        <span class="flex-1 break-words">{{ currentRelationData.head }}</span>
      </div>
    </div>
    <CategoryTitle class="mt-10px mb-5px" title="工单消缺"></CategoryTitle>
    <div class="text-14px" style="line-height: 28px">
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">工单编号：</span>
        <span class="flex-1 break-words">{{ currentRelationData.work_order_number }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">工单描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.work_order_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">工日：</span>
        <span class="flex-1 break-words">{{ currentRelationData.work_day }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">预案：</span>
        <span class="flex-1 break-words">{{ currentRelationData.reserve }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">效果：</span>
        <span class="flex-1 break-words">{{ currentRelationData.effect }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">缺陷原因及处理：</span>
        <span class="flex-1 break-words">{{ currentRelationData.reason }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">措施：</span>
        <span class="flex-1 break-words">{{ currentRelationData.measure }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障措施：</span>
        <span class="flex-1 break-words">{{ currentRelationData.fault_measures_code }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障现象：</span>
        <span class="flex-1 break-words">{{ currentRelationData.symptoms_code }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障措施描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.fault_measures_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">作业计划：</span>
        <span class="flex-1 break-words">{{ currentRelationData.work_type_code }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">作业计划描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.work_type_descs }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">维护单位：</span>
        <span class="flex-1 break-words">{{ currentRelationData.maintenance }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障原因：</span>
        <span class="flex-1 break-words">{{ currentRelationData.fault_reason_code }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">故障原因描述：</span>
        <span class="flex-1 break-words">{{ currentRelationData.fault_reason_desc }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">其它：</span>
        <span class="flex-1 break-words">{{ currentRelationData.risk_orther }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">需备防护救援器材：</span>
        <span class="flex-1 break-words">{{ currentRelationData.equipment_prodect }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">备注：</span>
        <span class="flex-1 break-words">{{ currentRelationData.note }}</span>
      </div>
      <div class="w-full flex text-white">
        <span class="w-150px flex justify-end truncate text-right">状态：</span>
        <span class="flex-1 break-words">{{ currentRelationData.status }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import { token1 } from './constant'

const baseUrl = Wiz.GetModuleServer()
export default {
  components: {
    CategoryTitle,
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {
          copyNodePtr: 0, // 暂存的节点
          copyMat: 0, // 暂存的材质
          defaultCameraInfo: null, // 默认视角参数
        }
      },
    },
  },
  data() {
    return {
      currentRelationData: {},
      defectLoginCode: '', // 缺陷登录编号
    }
  },
  watch: {
    transferProps: {
      handler(data) {
        this.currentRelationData = _.cloneDeep(data)
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.defaultCameraInfo = await this.player.Native.Camera.currentParam() // 获取默认相机信息
    this.player.Native.ModelTree.EventSelectItemChanged.connect((e) => {
      console.log(e, '点选模型了')
      this.getDefectLoginCode(e?.code)
    })
  },
  methods: {
    getDefectLoginCode(kksCode) {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login_limit/V1.0?token=${token1}&kks_code=${
          kksCode || ''
        }`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          this.defectLoginCode = res.data.data[0].defect_login_code
          this.getBasicInfo(this.defectLoginCode)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取缺陷基本信息
    getBasicInfo(dlCode) {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login/V1.0.1.1.1?token=${token1}&defect_login_code=${dlCode}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          if (res && res.data.data && res.data.data.items[0]) {
            // 获取消缺信息
            this.getWorkOrderInfo(dlCode, res.data.data.items[0])
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取消缺信息并更新数据
    getWorkOrderInfo(dlCode, basicInfo) {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_work_order/V1.0?token=${token1}&work_order_number=${dlCode}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          if (res && res.data.data && res.data.data[0]) {
            this.currentRelationData = {
              ...res.data.data[0],
              ...basicInfo,
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 恢复上一个node的颜色
    async resetColor() {
      if (this.copyNodePtr && this.copyMat) {
        await this.player.Native.NodeProxy.setNodeMaterial(this.copyNodePtr, this.copyMat)
      }
    },
    // 恢复相机
    async resetCamera() {
      await this.player.Native.Camera.moveTo(
        this.defaultCameraInfo.eye,
        this.defaultCameraInfo.target,
        this.defaultCameraInfo.up,
        1
      )
    },
    // 通过kks码定位模型设备区域
    async findNodeByCode(code) {
      await this.resetColor()
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(decodeURIComponent(code))
      console.log('codeInfo.nodePtr', codeInfo)
      if (codeInfo && codeInfo.nodePtr) {
        // 场景是以node的形式加载的
        await this.player.Native.Camera.moveToCode(decodeURIComponent(code), 1) // 相机跳转
        await this.player.Native.ModelTree.setSelectItem(codeInfo.item) // 模型选中
        this.copyNodePtr = codeInfo.nodePtr
        const mat = await this.player.Native.NodeProxy.getNodeMaterial(codeInfo.nodePtr) // 材质的指针句柄
        this.copyMat = await this.player.Native.NodeProxy.copyMaterial(mat) // 复制材质,暂存材质
        await this.player.Native.NodeProxy.setMaterialDiffuse(mat, 1253923583)
      } else {
        await this.resetCamera()
      }
      // await this.player.Native.ModelTree.restoreAllItemColor()
      // const codeInfo = await this.player.Native.ModelTree.getItemByCode(decodeURIComponent(code))
      // if (codeInfo && codeInfo.item) {
      //   await this.player.Native.ModelTree.setItemColor(codeInfo.item, 4278190335)
      //   // 移动到某个树节点位置
      //   this.player.Native.Camera.moveToCode(decodeURIComponent(code), 2)
      // }
    },
  },
  async beforeDestroy() {
    await this.resetColor()
    this.copyNodePtr = 0
    this.copyMat = 0
    await this.resetCamera()
  },
}
</script>

<style></style>
